import { render } from "./Enterprise_page_en_m.vue?vue&type=template&id=f8848324&scoped=true"
import script from "./Enterprise_page_en_m.vue?vue&type=script&lang=js"
export * from "./Enterprise_page_en_m.vue?vue&type=script&lang=js"

import "./Enterprise_page_en_m.vue?vue&type=style&index=0&id=f8848324&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f8848324"

export default script